var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Select, { components } from 'react-select';
import { DropdownWrapper, OptionIcon } from './Dropdown';
import styled from 'styled-components';
// eslint-disable-next-line no-undef
var OptionColor = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  height: 46px;\n  width: 4px;\n  position: absolute;\n  left: 0;\n  top: 1px;\n"], ["\n  background: ", ";\n  height: 46px;\n  width: 4px;\n  position: absolute;\n  left: 0;\n  top: 1px;\n"
    // eslint-disable-next-line no-undef
])), function (p) { return p.color; });
// eslint-disable-next-line no-undef
var OptionColorRounded = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  height: 48px;\n  width: 4px;\n  position: absolute;\n  left: 0;\n  top: -1px;\n\n  border-radius: 3px 0px 0px 3px;\n"], ["\n  background: ", ";\n  height: 48px;\n  width: 4px;\n  position: absolute;\n  left: 0;\n  top: -1px;\n\n  border-radius: 3px 0px 0px 3px;\n"])), function (p) { return p.color; });
export var ValueContainer = function (props) {
    var options = props.options;
    var currentOption = options.find(function (v) {
        return props.getValue() &&
            props.getValue()[0] &&
            v.value === props.getValue()[0].value;
    });
    return (React.createElement(React.Fragment, null,
        currentOption && currentOption.color && (React.createElement(OptionColorRounded, { color: currentOption.color })),
        React.createElement(components.ValueContainer, __assign({}, props))));
};
export var Option = function (props) { return (React.createElement(components.Option, __assign({}, props),
    props && props.data.color && React.createElement(OptionColor, { color: props.data.color }),
    props.children,
    props.isSelected && (React.createElement(OptionIcon, null,
        React.createElement("svg", { width: '11', height: '8', viewBox: '0 0 11 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            React.createElement("path", { d: 'M0.406428 4.07812L4.02859 7.67898L10.6763 1.05256L9.84535 0.22159L4.02859 6.01705L1.21609 3.24716L0.406428 4.07812Z', fill: '#FEFEFE' })))))); };
function Indicator(p) {
    return (React.createElement(components.DropdownIndicator, __assign({}, p),
        React.createElement("svg", { width: '14', height: '8', viewBox: '0 0 14 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6.64575 7.64588L0.636039 1.63617L1.34432 0.927891L6.99991 6.58349L12.6557 0.927918L13.3639 1.63618L7.35401 7.64587L6.99987 8L6.64575 7.64588Z', fill: '#FEFEFE' }))));
}
function Menu(p) {
    return React.createElement(components.Menu, __assign({}, p), p.children);
}
export function DropdownEditable(props) {
    return (React.createElement(DropdownWrapper, null,
        React.createElement(Select, __assign({ components: {
                DropdownIndicator: Indicator,
                Menu: Menu,
                ValueContainer: ValueContainer,
                Option: Option
            }, cacheOptions: true, maxMenuHeight: 172, className: 'brg-autofill', classNamePrefix: 'brg-input', noOptionsMessage: function () { return 'No such position'; }, isSearchable: true, isClearable: false }, props))));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=DropdownEditable.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Select, { components } from 'react-select';
import { DropdownWrapper, OptionIcon } from './Dropdown';
import styled from 'styled-components';
// eslint-disable-next-line no-undef
var OptionColor = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  height: 46px;\n  width: 4px;\n  position: absolute;\n  left: 0;\n  top: 1px;\n"], ["\n  background: ", ";\n  height: 46px;\n  width: 4px;\n  position: absolute;\n  left: 0;\n  top: 1px;\n"
    // eslint-disable-next-line no-undef
])), function (p) { return p.color; });
// eslint-disable-next-line no-undef
var OptionColorRounded = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  height: 48px;\n  width: 4px;\n  position: absolute;\n  left: 0;\n  top: -1px;\n\n  border-radius: 3px 0px 0px 3px;\n"], ["\n  background: ", ";\n  height: 48px;\n  width: 4px;\n  position: absolute;\n  left: 0;\n  top: -1px;\n\n  border-radius: 3px 0px 0px 3px;\n"])), function (p) { return p.color; });
export var ValueContainer = function (props) {
    var options = props.options;
    var currentOption = options.find(function (v) {
        return props.getValue() &&
            props.getValue()[0] &&
            v.value === props.getValue()[0].value;
    });
    return (React.createElement(React.Fragment, null,
        currentOption && currentOption.color && (React.createElement(OptionColorRounded, { color: currentOption.color })),
        React.createElement(components.ValueContainer, __assign({}, props))));
};
export var Option = function (props) { return (React.createElement(components.Option, __assign({}, props),
    props && props.data.color && React.createElement(OptionColor, { color: props.data.color }),
    props.children,
    props.isSelected && (React.createElement(OptionIcon, null,
        React.createElement("svg", { width: '11', height: '8', viewBox: '0 0 11 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            React.createElement("path", { d: 'M0.406428 4.07812L4.02859 7.67898L10.6763 1.05256L9.84535 0.22159L4.02859 6.01705L1.21609 3.24716L0.406428 4.07812Z', fill: '#FEFEFE' })))))); };
function Indicator(p) {
    return (React.createElement(components.DropdownIndicator, __assign({}, p),
        React.createElement("svg", { width: '14', height: '8', viewBox: '0 0 14 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
            React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6.64575 7.64588L0.636039 1.63617L1.34432 0.927891L6.99991 6.58349L12.6557 0.927918L13.3639 1.63618L7.35401 7.64587L6.99987 8L6.64575 7.64588Z', fill: '#FEFEFE' }))));
}
function Menu(p) {
    return React.createElement(components.Menu, __assign({}, p), p.children);
}
export function DropdownEditable(props) {
    return (React.createElement(DropdownWrapper, null,
        React.createElement(Select, __assign({ components: {
                DropdownIndicator: Indicator,
                Menu: Menu,
                ValueContainer: ValueContainer,
                Option: Option
            }, cacheOptions: true, maxMenuHeight: 172, className: 'brg-autofill', classNamePrefix: 'brg-input', noOptionsMessage: function () { return 'No such position'; }, isSearchable: true, isClearable: false }, props))));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=DropdownEditable.js.map